import { Controller } from "@hotwired/stimulus"
import { onMorph } from "../lib/reactor"
import { turboRefresh } from "../lib/helpers"

export default class extends Controller {
  static values = { timestamp: Number }

  connect() {
    onMorph(this)
    this.timer = setInterval(this.tick.bind(this), 1000)
    this.tick()
  }

  disconnect() {
    clearInterval(this.timer)
  }

  morph() {
    this.tick()
  }

  tick() {
    const remaining = Math.max(0, this.timestampValue - Math.floor(Date.now() / 1000))

    if (remaining === 0) {
      clearInterval(this.timer)
      turboRefresh()
    } else if (remaining >= 60) {
      const minutes = Math.ceil(remaining / 60)
      this.element.textContent = `${minutes} ${minutes === 1 ? "minute" : "minutes"}`
    } else {
      this.element.textContent = `${remaining} ${remaining === 1 ? "second" : "seconds"}`
    }
  }
}
